import React from "react";
import { useSelector } from "react-redux";
import Custom404 from "../../404";
import cloudfront from "helpers/cloudfront";
import { getCollectionLanding, getCollectionRecipesLanding } from "store/collectionReducer";
import CollectionShare from "components/CollectionShare";
import { getValidatedPageTitle } from "helpers/checkCollectionDirections";
import HeadTitle from "components/HeadTitle";

const MobileCollection = () => {
  const collection = useSelector(getCollectionLanding);
  const recipes = useSelector(getCollectionRecipesLanding);

  if (!collection.id) {
    return <Custom404 />;
  }

  const collectionCreator = collection.channel.title;
  const title = getValidatedPageTitle(collection.title, collectionCreator);

  return (
    <>
      <HeadTitle
        title={title}
        img={cloudfront({ href: collection.main_image_url, size: "medium" })}
        description={collection.description || ""}
      />

      <CollectionShare collection={collection} recipes={recipes} />
    </>
  );
};

export default MobileCollection;
